module.exports = __webpack_public_path__ + "img/article.21e6d781.gif";